function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

function normalizeBackendUrl(rawUrl) {
  if (!rawUrl || rawUrl === "same-origin" || rawUrl === "/") {
    return window.location.origin;
  }

  if (rawUrl.startsWith("/")) {
    return `${window.location.origin}${rawUrl}`.replace(/\/$/, "");
  }

  try {
    const parsedUrl = new URL(rawUrl);
    const currentHost = window.location.hostname;

    if (
      (parsedUrl.hostname === "localhost" || parsedUrl.hostname === "127.0.0.1") &&
      (currentHost === "localhost" || currentHost === "127.0.0.1")
    ) {
      parsedUrl.hostname = currentHost;
    }

    return parsedUrl.toString().replace(/\/$/, "");
  } catch (error) {
    return rawUrl;
  }
}

export function getBackendUrl() {
  return normalizeBackendUrl(getConfig("VITE_BACKEND_URL"));
}

export function getBackendApiUrl() {
  return `${getBackendUrl()}/backend`;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}

export function getWebPushPublicKey() {
  return getConfig("VITE_WEB_PUSH_PUBLIC_KEY", "");
}
